import { Logger } from '@gitbook/util-debug';

export const logger = Logger('app:analytics');
